import { React } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaTools } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const iframe =
  '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31090.149390425795!2d80.1590560786839!3d13.08215136012901!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52666a322c7eed%3A0x15cbbff0d16a7972!2sIndelect%20Technologies.Pvt.Ltd!5e0!3m2!1sen!2sin!4v1632380457902!5m2!1sen!2sin" width="100%" height="340" style="border:0; border-radius:10px;" allowfullscreen="" loading="lazy"></iframe>';

const Iframe = (props) => {
  return (
    <div
      style={{ width: "100%", maxWidth: 600, margin: "0 auto" }}
      dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }}
    />
  );
};

const Location = () => {
  return (
    <div className="page-container location-page">
      <p className="main-heading">
        <FaMapMarkerAlt style={{ marginRight: 10, color: '#005fa3', verticalAlign: 'middle' }} />
        Our Location
      </p>
      <div className="location-card">
        <div className="location-map-block">
          <Iframe iframe={iframe} />
        </div>
        <div className="location-contact-block">
          <h6 className="google-maps-heading" style={{ marginBottom: '1rem' }}>Contact</h6>
          <p className="contact-address">
            <FaMapMarkerAlt style={{ marginRight: 8, color: '#005fa3' }} />
            #15/53, 1st Floor, Thirunagar, Villivakkam, Chennai - 600 095
          </p>
          <p className="contact-email">
            <a href="mailto:salesindelect@gmail.com">
              <MdEmail style={{ marginRight: 8, color: '#005fa3' }} />
              salesindelect@gmail.com
            </a>
          </p>
          <p className="contact-phone">
            <FaPhoneAlt style={{ marginRight: 8, color: '#005fa3' }} /> Sales: +91 93802 43402
          </p>
          <p className="contact-phone">
            <FaTools style={{ marginRight: 8, color: '#005fa3' }} /> Service: +91 93825 43299
          </p>
        </div>
      </div>
    </div>
  );
};

export default Location;
